import { createSlice } from "@reduxjs/toolkit";

interface OverettState {
    isCreatingOverett: boolean;
    isEditingOverett: boolean;
    isOverettChartOpen: boolean;
    overettCreationStep: number;
    observationHeight: number;
    upperOverettAltitudeAboveTerrain: number;
    lowerOverettAltitudeAboveTerrain: number;
    isDraggingOverettLinje: boolean;
    overettAngle: number;
}

const initialState: OverettState = {
    isCreatingOverett: false,
    isEditingOverett: false,
    isOverettChartOpen: false,
    overettCreationStep: 0,
    observationHeight: 5,
    upperOverettAltitudeAboveTerrain: 4,
    lowerOverettAltitudeAboveTerrain: 4,
    isDraggingOverettLinje: false,
    overettAngle: 0,
};

const overettSlice = createSlice({
    name: "overett",
    initialState,
    reducers: {
        setIsCreatingOverett(state, action) {
            state.isCreatingOverett = action.payload;
        },
        setIsEditingOverett(state, action) {
            state.isEditingOverett = action.payload;
        },
        setIsOverettChartOpen(state, action) {
            state.isOverettChartOpen = action.payload;
        },
        setOverettCreationStep(state, action) {
            state.overettCreationStep = action.payload;
        },
        increaseOverettCreationStep(state) {
            state.overettCreationStep++;
        },
        decreaseOverettCreationStep(state) {
            state.overettCreationStep--;
        },
        setObservationHeight(state, action) {
            state.observationHeight = action.payload;
        },
        setUpperOverettAltitudeAboveTerrain(state, action) {
            state.upperOverettAltitudeAboveTerrain = action.payload;
        },
        setLowerOverettAltitudeAboveTerrain(state, action) {
            state.lowerOverettAltitudeAboveTerrain = action.payload;
        },
        setIsDraggingOverettLinje(state, action) {
            state.isDraggingOverettLinje = action.payload;
        },
        setOverettAngle(state, action) {
            state.overettAngle = action.payload;
        },
    },
});

export default overettSlice.reducer;
export const {
    setIsCreatingOverett,
    setIsEditingOverett,
    setIsOverettChartOpen,
    setOverettCreationStep,
    increaseOverettCreationStep,
    decreaseOverettCreationStep,
    setObservationHeight,
    setUpperOverettAltitudeAboveTerrain,
    setLowerOverettAltitudeAboveTerrain,
    setIsDraggingOverettLinje,
    setOverettAngle,
} = overettSlice.actions;
export type { OverettState };
